//containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '/containers-m/';

//context containers
import {
  Hero,
  Services,
  IntroductionText,
  CustomersLogos,
  Featured,
  FreightSection,
  SidePanels,
  LifeLoadVideo,
  ShipWithUs,
  Newsroom,
  ImageCTA,
  LogoImageCTA,
} from './containers/index';

import { HubspotFormSimplifiedV4 } from '@/containers-m/HubspotFormSimplified';

//styles
import { PageWrapper, HubspotFormWrapper } from './Home.styles';

//vendor
import { contactOptions } from '@/vendor/HubspotFormIntegration';

const form_content = {
  title: (
    <>
      Lower costs, increase efficiency, and digitize transportation with
      Loadsmart’s solutions
    </>
  ),
  subtitle: (
    <>
      Lower freight costs and boost performance with Loadsmart’s software and
      services.
    </>
  ),
};

function Home() {
  return (
    <PageWrapper>
      <Navigation theme="dark" />
      <>
        <Hero />
        <CustomersLogos />
        <Services />
        <FreightSection />
        <IntroductionText />
        <ImageCTA />
        <LogoImageCTA />
        <SidePanels />
        <Featured />
        <LifeLoadVideo />
        <Newsroom />
        <ShipWithUs />
        <HubspotFormWrapper id="contact-form">
          <HubspotFormSimplifiedV4
            content={form_content}
            {...contactOptions}
            disclaimer={true}
            theme="dark"
          />
        </HubspotFormWrapper>
      </>
      <Footer />
    </PageWrapper>
  );
}

export default Home;
export { Home };
